import {get} from 'lodash'
import store from '@/store'

export default function (inputsGroupState, mutationGroupPath, prefix = '') {
  const state = get(store.state, inputsGroupState)
  const result = {}

  for (const key in state.inputs) {
    result[prefix + key] = {
      // getter
      get: function () {
        return get(store.state, `${inputsGroupState}.inputs[${key}].value`)
      },
      // setter
      set: function (newValue) {
        store.commit(mutationGroupPath, [key, newValue])
      }
    }
  }

  return result
}
